import React from 'react';
import LoginForm from '../../../components/LoginForm';

const LoginPage = () => {
  return (
    <LoginForm nextPage={'/customer/dashboard'} userType={'customer'} />
  );
};

export default LoginPage;
